import type { Locale } from '@app/constants/Locales'
import { DEFAULT_LOCALE, LOCALES_LIST } from '@app/constants/Locales'

import { AppError } from '@app/errors/AppError'

import type { CookieInterface } from '@app/services/CookieManager'

import { createCookieName } from './cookieNames'
import { createCookie } from './cookies'
import moment from './moment'

export async function setLocale(locale: string, cookies: CookieInterface) {
  const supportedLocale = ensureLocale(locale)
  if (supportedLocale !== locale) throw new AppError(`Unknown locale:${locale}`).withHandled(true).withExpose(true).withStatus(400)

  await localeCookie.set(cookies, supportedLocale)
}

export async function getLocale(cookies: CookieInterface) {
  return ensureLocale((await localeCookie.get(cookies)) || DEFAULT_LOCALE)
}

function ensureLocale(locale: string): Locale {
  return LOCALES_LIST.indexOf(locale as any) === -1 ? DEFAULT_LOCALE : (locale as Locale)
}

/**
 * `ignoreConsent`, because the only writer is an explicit `?lang=` from the visitor and the
 * middleware answers it with a redirect: buffered until consent, the choice dies with the
 * request and the language silently never changes.
 */
const localeCookie = createCookie(
  createCookieName('kidsout_locale'),
  x => ensureLocale(x),
  x => x,
  () => ({ expires: moment().add(10, 'years'), ignoreConsent: true })
)
